import axios from "axios";
import Qs from "qs";
import { Message } from "element-ui";
import store from "../store";

// 允许携带Cookie
axios.defaults.withCredentials = true; //等同于在封装的实例里面设置

let baseURL = process.env.API_ROOT_ISR;

let instanceTmp = axios.create({
  baseURL,
  timeout: 10000,
  transformRequest: [
    function(data) {
      // formData格式，直接返回不做格式转换
      if (data instanceof FormData) {
        return data;
      }
      data = Qs.stringify(data);
      return data;
    },
  ],
});

// http请求拦截器
instanceTmp.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    Message.error({
      message: "加载超时",
    });
    return Promise.reject(error);
  }
);
// http响应拦截器
instanceTmp.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res.code == "5") {
      store.commit("toggleMaskState", true);
      return Promise.reject("error");
    } else {
      return response;
    }
  },
  (error) => {
    console.log("Error 888");
    return Promise.reject(error);
  }
);

export default {
  getAxios: instanceTmp,
};



// WEBPACK FOOTER //
// ./src/service/HttpService_ISR.js